import { Col, If, PageHeader, Row, Spacer, Tabs, Text } from '@app/components'
import { TabsProps } from '@app/types'
import { persistTabValue } from '@app/utils'
import { useRouter } from 'next/router'
import { Fragment, useEffect, useState } from 'react'

import { OffRampDrawer, OnRampDrawer } from './flows'

export const DepositAndWithdraw = ({ isForDrawer = false }) => {
  const router = useRouter()

  //work please
  const [activeTab, setActiveTab] = useState('deposit')

  useEffect(() => {
    const tab = router.query.tab as string
    if (tab?.toLowerCase() === 'withdraw') {
      setActiveTab('withdraw')
    }
  }, [])

  const items: TabsProps['items'] = [
    {
      children: <OnRampDrawer isForDrawer={isForDrawer} />,
      key: 'deposit',
      label: 'Deposit',
    },
    {
      children: <OffRampDrawer isForDrawer={isForDrawer} />,
      key: 'withdraw',
      label: 'Withdraw',
    },
  ]

  const handleTabChange = (value: string) => {
    setActiveTab(value)
    persistTabValue(value)
  }

  return (
    <Row>
      <If condition={!isForDrawer}>
        <Col span={24}>
          <PageHeader
            title={'Deposit And Withdraw'}
            disableBreadcrumb
            footer={
              <Fragment>
                {process.env.NEXT_PUBLIC_DEPOSIT_WITHDRAW_ON == 'true' ? (
                  <>
                    <Text>Deposit to or Withdraw from your Coast digital account</Text>
                    <Tabs centered activeKey={activeTab} items={items} onChange={handleTabChange} />
                    <Spacer />
                  </>
                ) : (
                  <>
                    <Text>
                      Deposits and Withdrawals are temporarilty turned off. Please monitor your email for updates on the
                      process and the re-release of this feature. Thanks, Management.
                    </Text>
                  </>
                )}
              </Fragment>
            }
          />
        </Col>
      </If>
    </Row>
  )

  //<Tabs centered defaultActiveKey="1" items={items} />
}
